import { render } from "./RegistroDatosPersonalesDos.vue?vue&type=template&id=3410bf53"
import script from "./RegistroDatosPersonalesDos.vue?vue&type=script&lang=js"
export * from "./RegistroDatosPersonalesDos.vue?vue&type=script&lang=js"

import "./RegistroDatosPersonalesDos.vue?vue&type=style&index=0&id=3410bf53&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__